export const ROOT_COMPONENT_ACTIVATED = 'ROOT_COMPONENT_ACTIVATED';
export const PROPERTY_INJECTED = 'PROPERTY_INJECTED';

export function activateRootComponent(vis) {
  return {
    type: ROOT_COMPONENT_ACTIVATED,
    vis
  };
}

export function injectProperty(obj) {
  return {
    type: PROPERTY_INJECTED,
    obj
  };
}
